import React, { useMemo } from 'react';

import useConfig from 'UI/customHooks/useConfig';

import { SkillExpertiseLevelTooltip } from './SkillExpertiseLevelTooltip';

export const useTooltipComponents = ({
  supportedLevels,
  synonymLevelDescriptions,
  disableFocusListener,
  disableTitleText,
}) => {
  const config = useConfig();

  return useMemo(() => {
    const defaultTooltips = {
      Expert: 'restrict:skill_expertise_tooltip_default_skill_type_expert',
      Beginner: 'restrict:skill_expertise_tooltip_default_skill_type_beginner',
      Experience: 'restrict:skill_expertise_tooltip_default_skill_type_experience',
      SuperExpert: 'restrict:skill_expertise_tooltip_default_skill_type_superexpert',
    };

    return supportedLevels
      .map(level => {
        const tooltipLocizeId = defaultTooltips[level];
        const defaultTooltipDisabled = !config.cms?.features?.expertiseTooltipEnabled;
        let customTooltip = null;

        if (!tooltipLocizeId && !synonymLevelDescriptions) {
          return React.Fragment;
        }

        if (Array.isArray(synonymLevelDescriptions)) {
          const matchedSynonymLevelDescription = synonymLevelDescriptions.find(
            synonymLevelDescription => synonymLevelDescription.level === level
          );

          customTooltip = matchedSynonymLevelDescription
            ? matchedSynonymLevelDescription.description
            : null;
        }

        return ({ children, additionalText }) => (
          <SkillExpertiseLevelTooltip
            level={level}
            supportedLevels={supportedLevels}
            tooltipLocizeId={tooltipLocizeId}
            customTooltip={customTooltip}
            defaultTooltipDisabled={defaultTooltipDisabled}
            disableFocusListener={disableFocusListener}
            additionalText={additionalText}
            disableTitleText={disableTitleText}
          >
            {children}
          </SkillExpertiseLevelTooltip>
        );
      })
      .reduce(
        (aggr, component, index) => ({
          ...aggr,
          [supportedLevels[index]]: component,
        }),
        {}
      );
  }, [supportedLevels, synonymLevelDescriptions, disableFocusListener, disableTitleText]);
};
